import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import httpServe from '../httpserve/httpServe.js'
import router from './router/router'
import * as echarts from 'echarts'
Vue.config.productionTip = false

Vue.prototype.$api = httpServe; //设置全局变量
Vue.prototype.$echarts = echarts
Vue.use(ElementUI);
new Vue({
	router,
  render: h => h(App),
}).$mount('#app')